// client/src/components/DynamicSEO.jsx
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { API_URL } from '../config';

const DynamicSEO = () => {
  const [seoSettings, setSeoSettings] = useState(null);

  useEffect(() => {
    const fetchSEOSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/site-settings`);
        if (response.ok) {
          const data = await response.json();
          setSeoSettings(data.seo);
        }
      } catch (error) {
        console.error('Failed to fetch SEO settings:', error);
      }
    };

    fetchSEOSettings();
  }, []);

  if (!seoSettings) {
    return null;
  }

  // Organization schema for Google
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    'name': 'TR Ventilation',
    'description': 'Professional HVAC and ventilation supplies for contractors and builders in Hull and Yorkshire',
    'url': 'https://trventilation.com',
    'telephone': '01482205358',
    'email': 'sales@trventilation.com',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': '25 Thurlstone Cloes',
      'addressLocality': 'Hull',
      'addressRegion': 'Yorkshire',
      'postalCode': 'HU7 5AN',
      'addressCountry': 'GB'
    },
    'areaServed': ['Hull', 'Yorkshire', 'UK'],
    'priceRange': '£',
    'image': 'https://trventilation.com/TRVentilation_logo.png',
    'sameAs': []
  };

  return (
    <Helmet>
      {seoSettings.title && <title>{seoSettings.title}</title>}
      {seoSettings.description && <meta name="description" content={seoSettings.description} />}
      {seoSettings.keywords && <meta name="keywords" content={seoSettings.keywords} />}
      {seoSettings.author && <meta name="author" content={seoSettings.author} />}

      {/* Canonical URL */}
      <link rel="canonical" href={window.location.href} />

      {/* Open Graph / Facebook */}
      {seoSettings.ogTitle && <meta property="og:title" content={seoSettings.ogTitle} />}
      {seoSettings.ogDescription && <meta property="og:description" content={seoSettings.ogDescription} />}
      {seoSettings.ogImage && <meta property="og:image" content={seoSettings.ogImage} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />

      {/* Twitter */}
      {seoSettings.twitterCard && <meta name="twitter:card" content={seoSettings.twitterCard} />}
      {seoSettings.twitterTitle && <meta name="twitter:title" content={seoSettings.twitterTitle} />}
      {seoSettings.twitterDescription && <meta name="twitter:description" content={seoSettings.twitterDescription} />}
      {seoSettings.twitterImage && <meta name="twitter:image" content={seoSettings.twitterImage} />}

      {/* JSON-LD Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default DynamicSEO;
